// @flow

import { useEffect } from 'react';

export function useRedirect(url: ?string, delay: number = 0) {
  useEffect(() => {
    let timeoutId;

    if(url) {
      timeoutId = setTimeout(() => {
        window.location = url;
      }, delay);
    }

    return () => clearTimeout(timeoutId);
  }, [url, delay]);
}
